import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    editHistoryData: [],
    isFetching: false,
    isSuccess: false,
    iseditHistorySucess: false,
    isPdfFileSended: false,
    isError: false,
    errorMessage: '',
};

export const fetchEditHistory = createAsyncThunk(
    '/clerk/editHistory?processId=',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            const response = await axios.get(`/api${userType}/editHistory?processId=` + udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const sendPdfForAppend = createAsyncThunk(
    'api/editHistory/append',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
            const response = await axios.post(`/api/${userType}/editHistory/append`, udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

            let data = response.data;

            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const documentEditHistorySlice = createSlice({
    name: 'documentedithistroy',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearEditHistroy: (state, { payload }) => {
            state.editHistoryData = [];
            state.isError = false;
            state.isFetching = false;
            state.errorMessage = '';
            state.iseditHistorySucess = false;
            state.isPdfFileSended = false;
        },
        clearSendPdfForAppend: (state, { payload }) => {
            state.isError = false;
            state.isFetching = false;
            state.errorMessage = '';
            state.isPdfFileSended = false;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [fetchEditHistory.fulfilled]: (state, { payload }) => {

            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success && payload.message !== "no data") {
                state.iseditHistorySucess = true;
                state.editHistoryData = payload.data;
                state.isFetching = false;
            }
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            if (payload.message === "no data") {
                state.isError = true;
            }
            // state.editHistoryData = payload.data;
            // state.isFetching = false;
            // state.iseditHistorySucess = true;
            return state;
        },
        [fetchEditHistory.pending]: (state) => {
            state.isFetching = true;
        },
        [fetchEditHistory.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },


        [sendPdfForAppend.fulfilled]: (state, { payload }) => {

            if (payload.success == false) state.isError = true;
            else state.isError = false;
            if (payload.success) {
                state.isPdfFileSended = true;
                state.isFetching = false;
            }
            if (payload.message) state.errorMessage = payload.message;
            else state.errorMessage = '';
            return state;
        },
        [sendPdfForAppend.pending]: (state) => {
            state.isFetching = true;
        },
        [sendPdfForAppend.rejected]: (state, { payload }) => {

            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },


    },
});




export const { clearEditHistroy, clearSendPdfForAppend } = documentEditHistorySlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearEditHistroy());
    }
}

export function clearStateSendPdfForAppend() {

    return async (dispatch) => {
        dispatch(clearSendPdfForAppend());
    }
}

export const documentEditHistorySelector = (state) => state.documentedithistroy;

export default documentEditHistorySlice.reducer;
